import { Card, Divider, Grid } from "@mui/material";
import { useFormik } from "formik";
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import DashboardLayout from "../../Components/LayoutContainers/DashboardLayout";
import MDBox from "../../Components/MDBox";
import MDButton from "../../Components/MDButton";
import MDDate from "../../Components/MDDate";
import MDInput from "../../Components/MDInput";
import MDSelect from "../../Components/MDSelect";
import DashboardNavbar from "../../Components/Navbars/DashboardNavbar";
import { AccountType } from "../../Types/Enums/BankAccountEnum";
import * as Yup from "yup";
import { BankAccountModel } from "../../Api/Models/BankAccountModel";
import AppLoading from "../../Components/MDLoading";
import { InfoToaast, SuccessToaast } from "../../utils/toast/Toast";
import { BankAccountDto } from "../../Types/Api/DTO/BankAccountDto";
import { useTranslation } from "react-i18next";

interface ILocation {
  edit: boolean;
  data: BankAccountDto;
}
const validationSchema = Yup.object().shape({
  BankName: Yup.string().typeError("نام بانک الزامی است").required("نام بانک الزامی است "),
  AccountType: Yup.number().typeError("نوع حساب الزامی است"),
  StartDate: Yup.string().typeError("تاریخ شروع الزامی است").required("تاریخ شروع الزامی است "),
  EndDate: Yup.string().typeError("تاریخ پایان الزامی است").required("تاریخ پایان الزامی است"),
  AccountNumber: Yup.string()
    .required("شماره حساب الزامی است")
    .typeError("شماره حساب صحیح نیست  ")
    .min(1, "شماره حساب حداقل باید 1 عدد باشد")
    .max(40, "شماره حساب حداکثر 40 حرف می باشد"),
    // .positive("نوع حساب الزامی است"),
  ManagerName: Yup.string().typeError("نام مدیر الزامی است").required("نام مدیر الزامی است "),
  PhoneNumber: Yup.number()
    .required("شماره تلفن الزامی است ")
    .typeError("شماره تلفن الزامی است ")
    .min(1, "شماره تلفن الزامی است ")
    .positive("شماره تلفن الزامی است "),
  Address: Yup.string().typeError("آدرس الزامی است").required("آدرس الزامی است"),
  Description: Yup.string(),
});
export default function AddOrEditBanks() {
  const [loading, setLoading] = useState<boolean>(true);
  const location = useLocation().state as ILocation;
  const navigate = useNavigate();

  let bankModel = new BankAccountModel();
  const formik = useFormik({
    initialValues: {
      BankName: "",
      AccountType: null,
      StartDate: "",
      EndDate: "",
      ManagerName: "",
      Address: "",
      AccountNumber: "",
      PhoneNumber: "",
      Description: "",
    },
    validationSchema: validationSchema,
    onSubmit: async (values) => {
      if (location?.data?.id == null) {
        await bankModel.crete(values).then((r) => {
          setLoading(false);
          SuccessToaast("عملیات با موفقیت انجام شد ");
        });
      } else {
        await bankModel.update(location.data.id, values).then((r) => {
          setLoading(false);
          InfoToaast("عملیات با موفقیت انجام شد ");
        });
      }
      navigate("/billing", { replace: true });
    },
  });
  useEffect(() => {
    if (typeof location === "undefined" || location == null) {
      navigate("/billing", { replace: true });
    } else {
      if (location.edit) {
        let vals = location.data;
        formik.setFieldValue("BankName", vals.BankName);
        formik.setFieldValue("AccountType", vals.AccountType);
        formik.setFieldValue("StartDate", vals.StartDate);
        formik.setFieldValue("EndDate", vals.EndDate);
        formik.setFieldValue("ManagerName", vals.ManagerName);
        formik.setFieldValue("Address", vals.Address);
        formik.setFieldValue("AccountNumber", vals.AccountNumber);
        formik.setFieldValue("PhoneNumber", vals.PhoneNumber);
        formik.setFieldValue("Description", vals.Description);
      }
      setLoading(false);
    }
    return () => {};
  }, []);

  return (
    <DashboardLayout>
      <DashboardNavbar name={"بانک / عملیات"} />
      <Card sx={{ width: "100%", padding: 2 }}>
        <MDBox component="form" role="form" onSubmit={formik.handleSubmit}>
          <MDBox mx={1}>
            <Grid container rowSpacing={1} spacing={2} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
              <Grid item xs={12}>
                <MDInput
                  name="BankName"
                  disabled={loading}
                  label="نام بانک"
                  fullWidth
                  onChange={formik.handleChange}
                  error={formik.touched.BankName && Boolean(formik.errors.BankName)}
                  helperText={formik.touched.BankName && formik.errors.BankName}
                  value={formik.values.BankName}
                />
                <Divider />
              </Grid>
              <Grid item xs={12}>
                <MDSelect
                  name="AccountType"
                  onChange={(e: any) => formik.setFieldValue("AccountType", parseInt(e))}
                  disabled={loading}
                  label="نوع حساب"
                  fullWidth
                  enumi={AccountType}
                  defaultValue={formik.values.AccountType}
                  error={formik.touched.AccountType && Boolean(formik.errors.AccountType)}
                  helperText={formik.touched.AccountType && formik.errors.AccountType}
                />
                <Divider />
              </Grid>

              <Grid item xs={12}>
                <MDDate
                  name="StartDate"
                  onChange={(e: any) => formik.setFieldValue("StartDate", e)}
                  disabled={loading}
                  defaultValue={formik.values.StartDate}
                  label={"تاریخ شروع"}
                  error={formik.touched.StartDate && Boolean(formik.errors.StartDate)}
                  helperText={formik.touched.StartDate && formik.errors.StartDate}
                />
                <Divider />
              </Grid>
              <Grid item xs={12}>
                <MDDate
                  name="StartDate"
                  onChange={(e: any) => formik.setFieldValue("EndDate", e)}
                  disabled={loading}
                  defaultValue={formik.values.EndDate}
                  label={"تاریخ پایان"}
                  error={formik.touched.EndDate && Boolean(formik.errors.EndDate)}
                  helperText={formik.touched.EndDate && formik.errors.EndDate}
                />
                <Divider />
              </Grid>
              <Grid item xs={12}>
                <MDInput
                  name="AccountNumber"
                  onChange={formik.handleChange}
                  disabled={loading}
                  label="شماره حساب"
                  fullWidth
                  error={formik.touched.AccountNumber && Boolean(formik.errors.AccountNumber)}
                  helperText={formik.touched.AccountNumber && formik.errors.AccountNumber}
                  value={formik.values.AccountNumber}
                />
                <Divider />
              </Grid>
              <Grid item xs={12}>
                <MDInput
                  name="ManagerName"
                  disabled={loading}
                  label="نام مدیر"
                  fullWidth
                  onChange={formik.handleChange}
                  error={formik.touched.ManagerName && Boolean(formik.errors.ManagerName)}
                  helperText={formik.touched.ManagerName && formik.errors.ManagerName}
                  value={formik.values.ManagerName}
                />
                <Divider />
              </Grid>
              <Grid item xs={12}>
                <MDInput
                  name="PhoneNumber"
                  // onChange={formik.handleChange}
                  disabled={loading}
                  label="شماره تماس"
                  fullWidth
                  onChange={formik.handleChange}
                  error={formik.touched.PhoneNumber && Boolean(formik.errors.PhoneNumber)}
                  helperText={formik.touched.PhoneNumber && formik.errors.PhoneNumber}
                  value={formik.values.PhoneNumber}
                />
                <Divider />
              </Grid>
              <Grid item xs={12}>
                <MDInput
                  name="Address"
                  // onChange={formik.handleChange}
                  disabled={loading}
                  label="آدرس"
                  fullWidth
                  multiline
                  onChange={formik.handleChange}
                  error={formik.touched.Address && Boolean(formik.errors.Address)}
                  helperText={formik.touched.Address && formik.errors.Address}
                  value={formik.values.Address}
                />
                <Divider />
              </Grid>
              <Grid item xs={12}>
                <MDInput
                  name="Description"
                  onChange={formik.handleChange}
                  disabled={loading}
                  label="توضیحات"
                  fullWidth
                  multiline
                  // onChange={formik.handleChange}
                  error={formik.touched.Description && Boolean(formik.errors.Description)}
                  helperText={formik.touched.Description && formik.errors.Description}
                  value={formik.values.Description}
                />
                <Divider />
              </Grid>
            </Grid>
          </MDBox>
          <Divider />
          <MDBox pb={2} px={2}>
            <Grid container spacing={3} justifyContent={"space-around"}>
              <Grid item xs={12} md={12} lg={6}>
                <MDBox>
                  <MDButton variant="gradient" color="success" type="submit" fullWidth>
                    ثبت
                  </MDButton>
                </MDBox>
              </Grid>
            </Grid>
          </MDBox>
        </MDBox>
      </Card>
      <AppLoading show={loading} />
    </DashboardLayout>
  );
}
